window.isCartTranslating = false;

window.triggerGTranslateFullReset = function () {
  if (window.isCartTranslating) return;
  window.isCartTranslating = true;

  const isFrench = document.documentElement.lang === 'fr' || 
                   document.documentElement.classList.contains('translated-ltr');

  if (!isFrench) {
    window.isCartTranslating = false;
    return;
  }

  const cartDrawer = document.querySelector('#CartDrawer');
  
  // 1. 给购物车加上微弱透明过渡，掩盖翻译跳变
  if (cartDrawer) {
    // cartDrawer.style.transition = 'opacity 0.15s ease';
    // cartDrawer.style.opacity = '0.5';
  }

  // 2. 执行真正的切语言重置
  if (typeof doGTranslate === 'function') {
    doGTranslate('en|en');
    setTimeout(function () {
      doGTranslate('en|fr');
    }, 50);
  }

  // 3. 400ms 后翻译完毕，恢复不透明度并解锁
  setTimeout(function () {
    if (cartDrawer) {
      cartDrawer.style.opacity = '1';
    }
    window.isCartTranslating = false;
  }, 450);
};

/*!
 * wb-lang-switch.js  |  多语言图片 / 视频切换（法语）
 * ---------------------------------------------------------------------------
 * 唯一的职责：监听 <html lang>（例如 <html class="js translated-ltr" lang="fr">）
 *   · lang 以 fr 开头 → 显示法语那一份、隐藏它对应的原图 / 原视频
 *   · 其它（en / 空）  → 显示原版、隐藏法语那一份
 *
 * 用法 —— 在原内容旁边，放一份法语内容（同一显示位置）：
 *
 *   <!-- 图片 -->
 *   <img class="desktop wb-img--en" src="英文图">
 *   <img class="desktop wb-img--fr" style="display:none" src="法语图">
 *
 *   <!-- 视频：整块容器（例如 <deferred-media>）在 class 末尾追加语言类名即可 -->
 *   <deferred-media class="video-section ... wb-img--en">…</deferred-media>
 *   <deferred-media class="video-section ... wb-img--fr" style="display:none">…</deferred-media>
 *
 *   └ 这两份的 class 除了 wb-img--en / wb-img--fr 之外必须完全一致，
 *     且放在同一个父元素里，才会被识别为"同一个位置的一组"。
 *
 * 回退（关键）：法语那一份没准备 / 没上传时 ——
 *   · 图片：src 留空（连 src 属性都不写也可以），或者干脆不写那一行
 *   · 视频：服务端不输出法语那一份
 *   这一组里就只剩原版，原版永远不会被隐藏 → 自动回退原版，绝不会出现空白。
 *
 * 另外：由 JS 之后才插进 DOM 的那部分内容（商品卡角标、相关推荐位、quick-add 弹窗等）
 *   会被自动补切一次，不需要额外调用 —— 详见下面 "晚到的内容" 那段观察器。
 *
 * 不写 cookie / localStorage / sessionStorage，不做其它任何事情。
 *
 * 安装（theme.liquid 的 <head> 里）：
 *   <script src="{{ 'wb-lang-switch.js' | asset_url }}"></script>
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var SEL = '.wb-img--en, .wb-img--fr';
  var EN = 'wb-img--en';
  var FR = 'wb-img--fr';
  var current = null;

  function isFr() {
    return (root.getAttribute('lang') || '').toLowerCase().indexOf('fr') === 0;
  }

  function show(el, on) {
    if (on) {
      if (el.style.display === 'none') el.style.display = '';
    } else if (el.style.display !== 'none') {
      el.style.display = 'none';
    }
  }

  function has(el, cls) {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }

  /**
   * 判断这个位置是否"真的有内容"：
   *   · <img>                → src 为空 = 还没上传法语图，按"没有这一份"处理（自动回退原图）
   *   · 非 <img>（视频容器）  → 没有 src 属性是正常的：视频由服务端决定输出几份
   *                            （只有法语视频上传了才会多输出一份），一律视为有内容
   */
  function ready(el) {
    var tag = el.tagName ? String(el.tagName).toLowerCase() : '';
    if (tag !== 'img') return true;
    var src = el.getAttribute('src');
    return !!src && src.replace(/\s/g, '') !== '';
  }

  var parents = [];

  /** 槽位标识 = 父元素 + 去掉 wb-img--en / wb-img--fr 之后的 class 组合 */
  function slotOf(el) {
    var all = (' ' + el.className + ' ').split(/\s+/);
    var keep = [];
    for (var i = 0; i < all.length; i++) {
      var c = all[i];
      if (c && c !== EN && c !== FR) keep.push(c);
    }
    keep.sort();
    var p = el.parentNode;
    var idx = parents.indexOf(p);
    if (idx < 0) idx = parents.push(p) - 1;
    return idx + '|' + keep.join('.');
  }

  function apply(force) {
    var fr = isFr();
    if (!force && fr === current) return;
    current = fr;

    var list = document.querySelectorAll(SEL);
    var groups = {};
    var i, el, key, g, isFrImg, groupHasFr;

    parents = [];

    for (i = 0; i < list.length; i++) {
      el = list[i];
      if (!ready(el)) {
        show(el, false);          // 还没填图 → 收起，并当作该位置没有法语图
        continue;
      }
      key = slotOf(el);
      (groups[key] || (groups[key] = [])).push(el);
    }

    for (key in groups) {
      if (!Object.prototype.hasOwnProperty.call(groups, key)) continue;
      g = groups[key];
      groupHasFr = false;
      for (i = 0; i < g.length; i++) {
        if (has(g[i], FR)) { groupHasFr = true; break; }
      }
      for (i = 0; i < g.length; i++) {
        isFrImg = has(g[i], FR);
        // 法语图：只在法语下显示
        // 原图：本组确实有法语图才参与切换，否则永远显示（自动回退）
        show(g[i], isFrImg ? fr : (groupHasFr ? !fr : true));
      }
    }
  }

  // 先同步跑一次（本文件不放 defer，能赶在首屏绘制前生效）
  apply(false);

  // ★ 核心：<html lang> 一变立刻切换 —— 翻译插件改写 lang 的瞬间就生效
  if (window.MutationObserver) {
    new MutationObserver(function () { apply(false); })
      .observe(root, { attributes: true, attributeFilter: ['lang'] });
  }

  /**
   * ★ 晚到的内容也要跟着切：
   *   商品卡角标、相关推荐位、quick-add 弹窗、搜索结果这类节点，是页面加载完成之后
   *   才由 JS 插进 DOM 的（典型如 <product-recommendations> 要滚到附近才 fetch）。
   *   它们出现的时候 <html lang> 早就定好了、不会再变 → 上面那个只监听 lang 的
   *   观察器永远等不到，结果就是它们在法语站上一直停在默认（英文）状态。
   *   所以这里补一个只盯"新增节点"的观察器，命中就强制重跑一次。
   */
  if (window.MutationObserver) {
    var queued = false;
    var rerun = function () {
      queued = false;
      apply(true);
    };
    new MutationObserver(function (records) {
      if (queued) return;
      for (var r = 0; r < records.length; r++) {
        var added = records[r].addedNodes;
        for (var a = 0; a < added.length; a++) {
          var node = added[a];
          if (node.nodeType !== 1) continue;          // 只关心元素节点
          if (node.matches(SEL) || node.querySelector(SEL)) {
            queued = true;                            // 同一帧内只重跑一次
            if (window.requestAnimationFrame) requestAnimationFrame(rerun);
            else setTimeout(rerun, 0);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // 兜底：极少数场景下图片是在 lang 确定之后才进 DOM，前 10 秒复查几次
  var start = Date.now();
  var timer = setInterval(function () {
    apply(true);
    if (Date.now() - start > 10000) clearInterval(timer);
  }, 300);

  document.addEventListener('DOMContentLoaded', function () { apply(true); });
  window.addEventListener('load', function () { apply(true); });
})();

/*!
 * ★ 防机翻保护区：Grouptify 尺寸选择器 + 价格块
 * ---------------------------------------------------------------------------
 * 1) 商品页"Dimensions"那一排尺寸 pill（如 20' × 12'）是 Grouptify 的
 *    swatch-scripts.js 在前端注入的（容器 class 为 .mpg-swatch）。
 *    GTranslate 会对注入后的 DOM 逐段机翻：英尺符号 ' 被当成 feet 译成
 *    "pi"（pied 缩写），且分段不稳定 → 20 Pi—Pi—Pi 这类碎片。
 *
 * 2) 价格块 .price（集合页卡片 + 商品页通用）：
 *    Google 翻译有时会把促销价和划线原价两个相邻文本节点当成一句话合并
 *    翻译，输出一个 <font> 包住两段数字 → 划线价结构被破坏、两价挤在一起。
 *    是否发生取决于它的分段决策 → 表现为"有时好有时坏"。
 *    价格本身（数字 + 货币符号）不需要机翻，整块 notranslate 一劳永逸。
 *
 * 处理：给这些元素补 notranslate + translate="no"，机翻引擎整块跳过。
 * 内容可能分多批注入（Grouptify 异步渲染、价格随变体切换重渲染），
 * 所以用观察器持续补（加过的会被 :not(.notranslate) 排除；
 * 本观察器只盯 childList，加 class 属于 attribute 变化 → 不会自激）。
 */
(function () {
  'use strict';
  if (!window.MutationObserver) return;
  var NO_TRANS_SEL = '.mpg-swatch:not(.notranslate), .price:not(.notranslate)';
  function markNoTranslate() {
    var list = document.querySelectorAll(NO_TRANS_SEL);
    for (var i = 0; i < list.length; i++) {
      list[i].classList.add('notranslate');
      list[i].setAttribute('translate', 'no');
    }
  }
  markNoTranslate();
  document.addEventListener('DOMContentLoaded', markNoTranslate);
  window.addEventListener('load', markNoTranslate);
  new MutationObserver(markNoTranslate)
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/*!
 * ★ 购物车抽屉（#CartDrawer）翻译补齐
 * ---------------------------------------------------------------------------
 * 【症状 A】法语站在抽屉里删商品，有概率不重翻。
 *   原监听回调开头 `if (window.isCartTranslating) return;` —— 翻译进行中（内部锁
 *   450ms）发生的 DOM 变更被【直接丢弃】、不排队；而删商品是"一次性整体重渲染"，
 *   丢掉这一次就没有后续变更来补 → 概率性失败（取决于动作是否落在锁窗口内）。
 *   另外它只认 addedNodes（只有节点被移除就漏），观察器还贴在 #CartDrawer 上。
 *   本节不修改原代码，只在其之外另起一套兜底。
 *
 * 【症状 B】首次点"加入购物车"弹出抽屉时，整页翻译来回翻好几次。
 *   实测（真机探针，10'x10' 凉亭商品页）：点一次加购，抽屉被重写 2 次 ——
 *     t≈0.9s  CartDrawer.renderContents  替换 #CartDrawer（30KB HTML）
 *     t≈1.2s  CartDrawerItems            再替换 .drawer__inner（items + footer）
 *   两个各自 400ms 去抖的触发源（原监听 + 本模块）去撞这两次重写：
 *     落在同一时间片 → 合成 1 轮；错开 → 2 轮。
 *   每轮 = en|en + en|fr 两次【全页】翻译（原函数固定这么写），于是页面上
 *   英语↔法语闪 4 次。由时序决定 → "有时好有时坏"。
 *
 * 【本节做法】单一调度器，把一次加购引发的多次重写合并成一轮：
 *   ① 静默期 QUIET：来一个信号就重新计时，抽屉安静下来才翻 → 一次加购只翻一轮；
 *   ② 最小间隔 MIN_GAP：两轮之间至少隔这么久，绝不会连着闪；
 *   ③ 最长等待 MAX_WAIT：内容一直在变时也不至于饿死，先翻一轮再说；
 *   ④ 原监听 / 其它代码调用 triggerGTranslateFullReset() 也走同一个调度器
 *      （它只是"又收到一个信号"，不再各翻各的）；但它若只是【重复报告】我们刚刚
 *      已经看到的同一次变化（它自己也去抖 400ms，属于同一批），就直接忽略
 *      —— 这是消灭"多翻一轮"的关键（我们的观察器盯着同一棵子树、且更宽，不会漏）。
 *   忙时只把信号记下来、忙完补跑 → 不丢信号（症状 A 的修法保留）。
 *
 * 【包装方式】这个函数就定义在本文件前面（page-fr.js 第一段），所以直接取现成的
 *   来包（原函数逐字节不动）。
 *   ⚠ 别再用 Object.defineProperty 的 get/set 去"接住赋值"——赋值早已发生，
 *     setter 永不触发 → real 恒为 null → 变成空操作、完全不翻译（踩过这个坑）。
 */
(function () {
  'use strict';
  if (!window.MutationObserver) return;
  if (window.__wbCartResetQueued) return;        // 防重复安装
  window.__wbCartResetQueued = true;

  var QUIET = 600;        // 抽屉安静这么久 → 才真正翻（实测量到的两次重写间隔 300~530ms，取大一点合并）
  var MIN_GAP = 1100;     // 两轮翻译的最小间隔（防止连续闪）
  var MAX_WAIT = 1800;    // 内容一直在变时的最长等待（先翻一轮）
  var DUP_MS = 1500;      // 外部调用的"重复报告"窗口（我们刚看到的那次变化，它又报一遍）
  var UNLOCK_MS = 600;    // 原函数内部锁 450ms，留余量

  var real = (typeof window.triggerGTranslateFullReset === 'function')
    ? window.triggerGTranslateFullReset
    : null;                                   // ★ 直接取现成的（见上面"包装方式"）

  var running = false;      // 一轮翻译是否在跑
  var timer = null;
  var lastRunAt = 0;        // 上一轮开始时间
  var lastSignalAt = 0;     // 最近一次"内容变了"
  var lastSeenAt = 0;       // 我们自己的观察器最近一次看到抽屉真实变化的时间
  var waitFrom = 0;         // 本轮排队最早的信号时间（MAX_WAIT 用）
  window.__wbCartResetCount = 0;   // 调试用：实际执行了几轮重翻

  /* ---------- 调度：静默期 + 最小间隔 + 最长等待 ---------- */
  function signal() {
    var now = Date.now();
    if (!waitFrom) waitFrom = now;
    lastSignalAt = now;
    if (timer) clearTimeout(timer);
    var wait = QUIET;
    if (now - waitFrom + QUIET > MAX_WAIT) {
      wait = Math.max(20, MAX_WAIT - (now - waitFrom));
    }
    timer = setTimeout(fire, wait + 15);
  }

  function fire() {
    timer = null;
    var now = Date.now();
    if (running) { signal(); return; }              // 忙 → 重新排队（信号不丢）
    var gap = now - lastRunAt;
    if (gap < MIN_GAP) {                            // 上一轮刚翻完 → 稍后再来
      lastSignalAt = now;
      timer = setTimeout(fire, MIN_GAP - gap + 15);
      return;
    }
    waitFrom = 0;
    running = true;
    lastRunAt = now;
    window.__wbCartResetCount++;
    try { real(); } catch (e) {}
    setTimeout(function () {
      running = false;
      if (lastSignalAt > lastRunAt) signal();       // ★ 忙期间的变更 → 补跑
    }, UNLOCK_MS);
  }

  /* 对外暴露的那个函数：原监听 / 其它代码调用它 */
  function requestReset() {
    // 它自己也去抖 400ms，报的多半是"我们刚看到的同一次变化"（同一批重写）→ 忽略，
    // 否则会多翻一轮。真的漏了（>1.5s 前那次变化）才当作新信号。
    if (Date.now() - lastSeenAt <= DUP_MS) return;
    signal();
  }

  if (real) {
    try { window.triggerGTranslateFullReset = requestReset; } catch (e) {}
  } else if (window.Object && Object.defineProperty) {
    // 极端情况：本文件先于用户的函数加载 → 用 setter 接住后续那次赋值
    try {
      Object.defineProperty(window, 'triggerGTranslateFullReset', {
        configurable: true,
        get: function () { return requestReset; },
        set: function (fn) { real = fn; }
      });
    } catch (e) {}
  }

  /* ---------- 自己盯 #CartDrawer 内部的真实增删 ---------- */
  var DRAWER = '#CartDrawer';
  var sawDrawer = !!document.querySelector(DRAWER);
  // 解析期间不理会：服务端渲染的抽屉内容是一个节点一个节点冒出来的，
  // 那些都会命中下面的判断，会在每次页面加载时白翻一轮（实测过）。
  var armed = document.readyState !== 'loading';
  if (!armed) {
    document.addEventListener('DOMContentLoaded', function () {
      armed = true;
      sawDrawer = !!document.querySelector(DRAWER);
    });
  }

  function isNoise(node) {                 // 翻译引擎自己造成的变动 → 不算信号
    if (!node || node.nodeType !== 1) return true;    // 文本节点（翻译还原会替换文本）
    var n = node.nodeName;
    if (n === 'FONT' || n === 'SCRIPT' || n === 'STYLE' || n === 'LINK' ||
        n === 'NOSCRIPT' || n === 'TEMPLATE') return true;
    var cls = (typeof node.className === 'string') ? node.className : '';
    if (cls && /(^|\s)(skiptranslate|goog[\w-]*|translated-(ltr|rtl))(\s|$)/.test(cls)) return true;
    return false;
  }
  function inside(el) {
    return !!(el && el.closest && el.closest(DRAWER));
  }
  function isDrawer(node) {                // 整个抽屉被整体替换/重新插入
    return !!(node && node.nodeType === 1 &&
      (node.id === 'CartDrawer' || (node.querySelector && node.querySelector(DRAWER))));
  }

  new MutationObserver(function (records) {
    if (!armed) return;
    var hadDrawer = sawDrawer;             // 本批次开始前抽屉在不在（同批次里的插入不算"重新插入"）
    var hit = false, i, j, m, n;
    for (i = 0; i < records.length && !hit; i++) {
      m = records[i];
      var inDrawer = inside(m.target);     // 只看抽屉内部发生的变更
      for (j = 0; j < m.addedNodes.length; j++) {
        n = m.addedNodes[j];
        if (isNoise(n)) continue;
        if (inDrawer) { hit = true; break; }
        if (isDrawer(n)) {
          if (hadDrawer) { hit = true; break; }   // 重新插入才算，首次挂载不算
          sawDrawer = true;
        }
      }
      if (hit) break;
      for (j = 0; j < m.removedNodes.length; j++) {   // ★ 删商品常走这里
        n = m.removedNodes[j];
        if (isNoise(n)) continue;
        if (inDrawer || (isDrawer(n) && hadDrawer)) { hit = true; break; }
      }
    }
    if (!hit) return;
    lastSeenAt = Date.now();                // 记录"我们确实看到抽屉变了"（供去重用）
    signal();                               // 只发信号，翻不翻由统一调度器决定
  }).observe(document.documentElement || document, { childList: true, subtree: true });
})();
